export const authTypes = {
  SET_IS_LOGGED_IN_USER: "SET_IS_LOGGED_IN_USER",
  SET_LOGIN_LOADING: "SET_LOGIN_LOADING",
  SET_RESET_PASSWORD_lOADING: "SET_RESET_PASSWORD_lOADING",
};
